import { requestFromServer } from './api-client';
import { formattedDate } from '../utils/date';

export const SchedulingStatus = Object.freeze({
   scheduled: 'agendado',
   rescheduled: 'reagendado',
   inLine: 'fila',
   called: 'chamado',
   transit: 'transito',
   inProgress: 'atendimento',
   delayed: 'atrasado',
   canceled: 'cancelado',
   completed: 'concluido',
   all: 'todos',
});

export default {
  listWithFilter: ({
    schedulingDate,
    branches,
    plants,
    truckPlate,
    client,
    timeBlock,
    shouldGetPendings
  }) => {
    const params = {
      ...(branches?.length ? { branches } : {}),
      ...(truckPlate ? { truckPlate } : {}),
      ...(timeBlock ? { timeBlock } : {}),
      ...(shouldGetPendings ? { shouldGetPendings } : {}),
      ...(plants?.length ? { plants } : {}),
    };

    const searchParams = new URLSearchParams(params);

    if (schedulingDate instanceof Date) {
      schedulingDate = formattedDate(schedulingDate);
    }

    return requestFromServer(`v1/Schedulings/list/${schedulingDate}/${client || 0}?${searchParams}`);
  },

  add: timeBlock => requestFromServer(`v1/Schedulings/add`, 'POST', timeBlock),

  get: id => requestFromServer(`v1/Schedulings/get/${id}`),

  getStatus: id => requestFromServer(`v1/Schedulings/status/${id}`),

  update: timeBlock => requestFromServer(`v1/Schedulings/update/${timeBlock.id}`, 'PUT', timeBlock),

  cancel: (id, reason) => requestFromServer(`v1/Schedulings/cancel/${id}`, 'PUT', { reason }),

  checkinDriver: id => requestFromServer(`v1/Schedulings/checkinDriver/${id}`, 'POST'),

  findByBarcode: barcode => requestFromServer(`v1/Schedulings/findByBarcode?barcode=${barcode}`),

  start: id => requestFromServer(`v1/Schedulings/start/${id}`, 'POST'),

  finish: id => requestFromServer(`v1/Schedulings/finish/${id}`, 'POST'),

  setRDSNumber: (id, RDSNumber) => requestFromServer(`v1/Schedulings/setRDSNumber/${id}/${RDSNumber}`, 'POST'),

  delete: id => requestFromServer(`v1/Schedulings/delete/${id}`, 'delete'),

  listClients: _ => requestFromServer(`v1/Schedulings/listClients`, 'GET'),

  listTimeBlocks: ({ date, branches }) => {
    const params = {
       ...(branches?.length ? { branches } : {}),
       date: date instanceof Date ? formattedDate(date) : date
    };

    const searchParams = new URLSearchParams(params);

    return requestFromServer(`v1/Schedulings/listTimeBlocks?${searchParams}`, 'GET')
  },

  called: id => requestFromServer(`v1/Schedulings/called/${id}`, 'PUT'),

  calleds: (payload) => requestFromServer(`v1/Schedulings/calleds/${payload.branch}/${payload.quantity}`, 'POST'),

  saveAdditionalInfoCalled: (payload) => requestFromServer(`v1/Schedulings/saveAdditionalInfoToCalled/${payload.id}`, 'PUT', payload),

  inTransit: id => requestFromServer(`v1/Schedulings/inTransit/${id}`, 'PUT'),
  getReservationTypes: () => requestFromServer(`v1/Schedulings/getReservationTypes`, 'GET'),

  updateDriverPrimaryPhone: (payload) => requestFromServer(`v1/Schedulings/updateDriverPrimaryPhone/${payload.id}`, 'PUT', payload.body),

  updateDriverSecondaryPhone: (payload) => requestFromServer(`v1/Schedulings/updateDriverSecondaryPhone/${payload.id}`, 'PUT', payload.body),

  getCallMessages: (id) => requestFromServer(`v1/Schedulings/getCallMessages/${id}`, 'GET'),

  driverResponse: (payload) => requestFromServer(`v1/Schedulings/driverResponse/`, 'POST', payload),

  updateStatusMessage: (payload) => requestFromServer(`v1/Schedulings/updateStatusMessage`, 'POST', payload),

  getClientQuantitySchedulingByPeriod: (payload) => requestFromServer(`v1/Schedulings/getClientQuantitySchedulingByPeriod/${payload.client_document}/${payload.startDate}/${payload.endDate}`)
};

export const downloadResume = async id => {
  const pdfWindow = window.open('', '_blank');

  try {
    const response = await requestFromServer(`v1/Schedulings/resume/${id}`, 'GET', null, true, {
      responseType: 'blob',
    });
    const pdfUrl = window.URL.createObjectURL(response.data);

    if (pdfWindow) {
      pdfWindow.location.href = pdfUrl;
    } else {
      window.open(pdfUrl, '_blank');
    }

    setTimeout(() => window.URL.revokeObjectURL(pdfUrl), 60000);
  } catch (error) {
    if (pdfWindow) {
      pdfWindow.close();
    }
    throw error;
  }
};
